export default function ReportViewer() {
  return (
    <div className="my-8">
      <h2 className="text-xl font-semibold mb-4">Current Project</h2>
      <p className = "text-gray-600 mb-4"> Recently, I led
        my ENVE 153 team, Great Foundations, to develop a cost efficient
        embankment for flooding control, using various soil property 
        calculations, for the City of Cambridge. The project proposal took
        place in stages, from proposal to cost analysis, to cost optimizaiton, 
        and more. Here is our final report for the project. See the appendices, 
        specfically page 59 for the CAD drawings I used for calculations
        and drew using AutoCAD. This represented our overall design solution.
      </p>
      <iframe
        src="/reports/City of Cambridge Development Project.pdf"
        title="City of Cambridge Development Project"
        width="100%"
        height="600px"
        className="border rounded"
      />
    </div>
  );
}
